module.exports = __webpack_public_path__ + "static/muriwai-milkyway-756273e8a8e77bef45b1dd944e8f0ce6.jpg";